export const KbSelectionConstant = {
  heading_Main: {
    en: "Select Cadre and Knowledge Base",
    hi: "सेलेक्ट करें: भूमिका और नॉलेज बेस",
    or: "Select Cadre and Knowledge Base",
  },
  select: {
    en: "Select ",
    hi: "सेलेक्ट करें: ",
    or: "Select ",
  },
  and: {
    en: " and ",
    hi: " और ",
    or: " and ",
  },
  subheading_info: {
    en: "You can ask questions and retrieve answers based on your selected combination only.",
    hi: "आप केवल अपनी सेलेक्टेड  भूमिका और नॉलेज बेस  के आधार पर प्रश्न पूछ सकते हैं और उत्तर प्राप्त कर सकते हैं।",
    or: "You can ask questions and retrieve answers based on your selected combination only.",
  },
  subheading_update: {
    en: "You can update your selection each time you log in.",
    hi: "आप प्रत्येक लॉगिन पर अपनी सेलेक्शन  को अपडेट कर सकते हैं।",
    or: "You can update your selection each time you log in.",
  },
  proceedButton: {
    en: "Proceed",
    hi: "आगे बढ़ें",
    or: "Proceed",
  },
  cadre: {
    en: "Cadre",
    hi: "भूमिका",
    or: "Cadre",
  },
  kb: {
    en: "Knowledge Base",
    hi: "नॉलेज बेस",
    or: "Knowledge Base",
  },
  approach: {
    en: "Approach",
    hi: "अपरोच",
    or: "Approach",
  },
  input_cadre: {
    en: "Select the Cadre",
    hi: "भूमिका सेलेक्ट करें",
    or: "Select the Cadre",
  },
  input_kb:{
    en: "Select the KB",
    hi: "नॉलेज बेस सेलेक्ट करें",
    or: "Select the KB",
  },
  input_approach: {
    en: "Select the Approach",
    hi: "अपरोच सेलेक्ट करें",
    or: "Select the Approach",
  }
};
